import { z } from 'zod';
export const loginSchema = z.object({
    password: z.string().min(1),
});
export const contactSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    primaryEmail: z.string().email().optional(),
    primaryPhone: z.string().optional(),
    businessName: z.string().optional(),
    category: z.string().min(1),
    source: z.string().default('manual'),
    notes: z.string().optional(),
});
export const settingSchema = z.object({
    key: z.string().min(1),
    value: z.string(),
});
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=index.js.map